import { useEffect, useRef } from 'react'
import VConsole from 'vconsole'

const useVConsole = () => {
  const vConsole = useRef<any>(null)
  useEffect(() => {
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'production') {
      vConsole.current = new VConsole()
    }
    return () => {
      vConsole.current && vConsole.current.destroy()
    }
  }, [])
}

export default useVConsole
